import { useCallback } from 'react'
import { createSystemOpportunityName } from '@user/components/Opportunities/OpportunityName/functions'
import { IServiceProduct } from '@user/store/serviceProducts/typings'

export function useOpportunity(allServices: Map<string, IServiceProduct[]>) {
  const assignOpportunityName = useCallback(
    (record) => {
      const newRecord = { ...record }
      const { opportunityName, serviceId, branchId } = newRecord.row

      if (
        opportunityName &&
        !opportunityName.value &&
        serviceId?.value &&
        branchId?.value
      ) {
        const service = allServices
          .get(branchId?.value)
          ?.find((x) => x.id === serviceId.value)

        if (service) {
          opportunityName.value = createSystemOpportunityName([service])
        }
      }

      return newRecord
    },
    [allServices],
  )

  return {
    assignOpportunityName,
  }
}
